import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, InputLabel, Select, MenuItem, TextField, Box, Typography } from "@mui/material";
import { updateJobPromotionStatus, updateJobPromotionStatusReset } from "../../state/jobPromotion/jobPromotionSlice";
import { selectJobPromotionState } from "../../state/jobPromotion/jobPromotionSelector";

const JOB_PROMOTION_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

const JobPromotionStatusModal = ({ open, onClose, promotion }) => {
  const dispatch = useDispatch();
  const { isUpdating, isUpdateSuccess } = useSelector(selectJobPromotionState);
  const [status, setStatus] = useState(promotion?.status || JOB_PROMOTION_STATUS.PENDING);
  const [adminNote, setAdminNote] = useState("");

  useEffect(() => {
    if (promotion) {
      setStatus(promotion.status);
      setAdminNote(promotion.adminNote || "");
    }
  }, [promotion]);

  useEffect(() => {
    if (isUpdateSuccess) {
      onClose();
      dispatch(updateJobPromotionStatusReset());
    }
  }, [isUpdateSuccess, onClose, dispatch]);

  const handleSubmit = () => {
    dispatch(
      updateJobPromotionStatus({
        id: promotion.id,
        status,
        adminNote,
      })
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Update Promotion Status</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 3 }}>
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Job: <strong>{promotion?.jobPost?.title}</strong>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Company: <strong>{promotion?.companyInfo?.name}</strong>
            </Typography>
          </Box>

          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select value={status} label="Status" onChange={(e) => setStatus(e.target.value)}>
              <MenuItem value={JOB_PROMOTION_STATUS.PENDING}>Pending</MenuItem>
              <MenuItem value={JOB_PROMOTION_STATUS.APPROVED}>Approved</MenuItem>
              <MenuItem value={JOB_PROMOTION_STATUS.REJECTED}>Rejected</MenuItem>
            </Select>
          </FormControl>

          <TextField label="Admin Note" multiline rows={4} fullWidth value={adminNote} onChange={(e) => setAdminNote(e.target.value)} placeholder="Add a note for the employer..." />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={isUpdating} sx={{ minWidth: 120 }}>
          {isUpdating ? "Updating..." : "Update Status"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default JobPromotionStatusModal;
